import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";

import languageVersions from "./languageVersions.json";

// Host apps (cointrader) send `pt-br` / `ar-ae`; keep aliases → file stems.
const langMapping = {
  "ar-AE": "ar-ae",
  "ar-ae": "ar-ae",
  ar: "ar-ae",
  en: "en",
  pt: "pt",
  "pt-BR": "pt",
  "pt-br": "pt",
};

const getMappedLang = (lang) => langMapping[lang] || lang;

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: "en",
    fallbackLng: "en",
    load: "all",
    backend: {
      loadPath: (lngs) => {
        const lang = lngs[0];
        const mappedLang = getMappedLang(lang);
        const version = languageVersions[mappedLang] || "1";
        return `/lang/${mappedLang}.${version}.json`;
      },
      getVersion: (language) => {
        const mappedLang = getMappedLang(language);
        return languageVersions[mappedLang] || "1";
      },
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
